import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import BackButton from "../../helpers/BackButton";
import { Breadcrumb, Layout, Menu, Typography, DatePicker } from "antd";
import { Space, Table, Tag, Button } from "antd";
import TokenService from "../../../services/token.service";
import PageWrapper from "../../helpers/PageWrapper";
import streamService from '../../../services/streamService';
import { Link, Route, Routes } from "react-router-dom";
import { Input, Form, Select, InputNumber, message } from 'antd';
// import { LessonDtoRequest } from '../../interfaces/LessonDtoRequest';
import authAxios from "../../../services/api";
import { useParams } from 'react-router';
const { Title } = Typography;
const styles = { width: '800px', margin: '0 auto' };

const { Option } = Select;
const AssessmentsByGroups = () => {
  const [groups, setGroups] = useState([]);
  const [streams, setStreams] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState();
  const [selectedGroupName, setSelectedGroupName] = useState();

  const [showTable, setShowTable] = useState(false);


  useEffect(() => {

    authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/group`, {
      headers: {
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
      }
    })
      .then((response) => {
        setGroups(response.data);

      })
      .catch((err) => {
        console.log(err.message);
      });

  }, []);
  const mergeArraysGroup = (arr1) => {
    return arr1.map((group) => {

      return group;
    })
  };

  const groupArrays = mergeArraysGroup(groups)
  



  const handleOnChangeGroup = (value) => {
    setSelectedGroupId(value)

    let groupId = selectedGroupId

    authAxios.get(`http://85.159.27.198:8080/abitur/api/v1/group/${value}/streams`, {
      headers: {
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
      }
    })
      .then(res => {
        console.log(res.data);
        setStreams(res.data)
        // window.location.reload();
      })
      .finally(() => setShowTable(true))

  };
  
  return (
    <PageWrapper>

      <Typography.Title level={1}>Журналы</Typography.Title>
      <section>
        <Space size={20} direction={'vertical'}>
          <Select
            placeholder="Выберите группу"
            style={{ width: 400 }}
            value={selectedGroupId}
            onChange={handleOnChangeGroup}
          >
            {groupArrays.map((option) => (
              <Option key={option.id} value={option.id} >
                {option.surname} {option.name} {option.patronymic}
              </Option>
            ))}
          </Select>


        </Space>
        <br />
        <br />
        <Space size={20}>
          {/* <Button type={'default'} onClick={handleSubmit}>
            Search
          </Button> */}
          <br />
        </Space>
      </section>
      {selectedGroupId && (
        <>
          <Typography.Title level={2}>


          </Typography.Title>
          {/* <TranscriptTable key={selectedStudent} userId={selectedStudent} userRerender={rerender} /> */}
          {
            showTable && (
              <Table
                pagination={{ defaultPageSize: 10 }}
                columns={
                  [
                    {
                      title: "№",
                      dataIndex: "key",
                      key: "key",
                    },
                    {
                      title: "Дисциплина",
                      dataIndex: "discipline",
                      key: "discipline",
                    },
                    {
                      title: "Преподаватель",
                      dataIndex: "teacher",
                      key: "teacher",
                    },
                    {
                      title: "Поток",
                      dataIndex: "stream",
                      key: "stream",
                    },
                    {
                      title: "Оценки",
                      key: "assessments",
                      render: (_, record) => (
                        <Space size="middle">
                          <Link to={`/assessments-page/teacher-id/${record.teacherId}/stream-id/${record.streamId}`}>Оценки</Link>
                        </Space>
                      ),
                    },
                    {
                      title: "Уроки",
                      key: "lessons",
                      render: (_, record) => (
                        <Space size="middle">
                          <Link to={`/lesson-plan-page/teacherId/${record.teacherId}/stream-id/${record.streamId}`}>Уроки</Link>
                        </Space>
                      ),
                    },

                  ]}

                dataSource={
                  streams.map((stream, i) => ({
                    key: i + 1,
                    teacherId: stream.teacher.id,
                    streamId: stream.id,
                    discipline: stream.discipline.nameRu + '/' + stream.discipline.name,
                    stream: stream.name,
                    teacher: stream.teacher.surname + " " + stream.teacher.name + " " + stream.teacher.patronymic,
                  }))
                }
              />
            )
          }
        </>
      )}


    </PageWrapper>



  )
}


export default AssessmentsByGroups;